export const variantSeparator = '___variant-separator___'

export const COMP_TYPES_WITH_SPECIFIC_VARS = [
	'TPASection',
	'TPAMultiSection',
	'TPAWidget',
	'TPAGluedWidget',
	'tpaWidgetNative',
	'SlideShowSlide',
]

export const FALLBACK_MINIMUM_VIEWPORT = 320
export const FALLBACK_MAXIMUM_VIEWPORT = 1920

export const ESCAPING_CSS_PREFIX = '/*__css('
export const ESCAPING_CSS_SUFFIX = ')__css*/'
